import React, { createContext, useState } from "react";
import { useSearchParams } from "react-router-dom";

export interface ICandidateTabContext {
  currentTab: string;
  handleTabChange: (newTab: string) => void;
  hasCampaignResponses: boolean;
  setHasCampaignResponses: React.Dispatch<React.SetStateAction<boolean>>;
}

export const CandidateCurrentTabContext = createContext<ICandidateTabContext>({} as ICandidateTabContext);

export function CandidateTabContextProvider({ children }: React.PropsWithChildren<unknown>) {
  const {
    getters: { currentTab, hasCampaignResponses },
    setters: { setHasCampaignResponses },
    handlers: { handleTabChange },
  } = useCandidateTabsState();
  return (
    <CandidateCurrentTabContext.Provider
      value={{ currentTab, handleTabChange, hasCampaignResponses, setHasCampaignResponses }}
    >
      {children}
    </CandidateCurrentTabContext.Provider>
  );
}

export default function useCandidateTabsState() {
  const [search, setSearch] = useSearchParams();
  const [currentTab, setCurrentTab] = useState(search.get("tab") || "Notes");
  const [hasCampaignResponses, setHasCampaignResponses] = useState(true);

  function handleTabChange(newTab: string) {
    setCurrentTab(newTab);
    setSearch({ tab: newTab });
  }

  return {
    effects: {},
    getters: {
      currentTab,
      hasCampaignResponses,
    },
    handlers: {
      handleTabChange,
    },
    setters: {
      setHasCampaignResponses,
    },
  };
}
